/**
 * Traffic vs non-traffic case types. Mirrors backend/src/config/matterTypes.ts.
 *
 * Lloyd, Aug 6 2026: Texas banned THC and the firm has begun taking county- and district-court
 * criminal work. Those matters need to exist here for billing, but must not run the traffic
 * workflow — no letter of representation, no ticket-number requirement, no progression chart, no
 * follow-ups or stale flagging.
 *
 * Deliberately separate from referralSources.ts: source is where the client came from, this is what
 * kind of case it is, and a criminal matter has both.
 */

export const MATTER_TYPES = ['TRAFFIC', 'NON_TRAFFIC'] as const;
export type MatterType = (typeof MATTER_TYPES)[number];

export const MATTER_TYPE_LABELS: Record<MatterType, string> = {
  TRAFFIC: 'Traffic',
  NON_TRAFFIC: 'Non-traffic (criminal)',
};

/**
 * Null and unrecognised values read as traffic — the same rule the server applies.
 *
 * Cases that pre-date this field carry null, and they are all traffic. Reading an unset value as
 * non-traffic would hide the progression bar and stop stale flagging on live traffic cases.
 */
export function isTrafficMatter(matterType: string | null | undefined): boolean {
  return matterType !== 'NON_TRAFFIC';
}

/** Shown wherever staff need to know why the traffic tooling has gone quiet on a case. */
export const NON_TRAFFIC_EXPLANATION =
  'No letter of representation, ticket number, progression chart or follow-up reminders. ' +
  'Billing is unchanged. File the entry of appearance through the court’s own system.';
